import {ThirdPartyTokenChannel} from "@irati/types"
import PBService from "../../services"
import client, {MutationOptions} from "../../services/apollo"
import tokenQuery, {tokenKey} from "./queries/token"

class IntercomToken extends PBService {
  get(channel: ThirdPartyTokenChannel, options: MutationOptions = {}) {
    return client.query({...options, variables: {channel}, query: tokenQuery}).then(({data}) => data[tokenKey])
  }
}

const intercomTokenService = new IntercomToken({errorHandlers: []})

export default intercomTokenService
